<template>
  <v-toolbar
    id="menuToolbar"
    app
    fixed
    dark
    prominent
    class="pr-0"
    color="primary"
    style="z-index: 10"
  >
    <template v-if="[1, 2].includes($route.meta.plataforma)">
      <div id="menuLogo" class="text-center d-flex align-center menuLogo">
        <v-menu
          v-if="frota && seguros"
          attach="#menuLogo"
          auto
          @input="state => (menuAtivo = state)"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="$route.name !== 'GridSolicitacaoCotacao' && $route.name !== 'GridCadastroVeiculos'"
              class="button-logo"
              color="primary"
              dark
              depressed
              v-bind="attrs"
              v-on="on"
            >
              <div class="">
                <img
                  v-if="$route.meta.plataforma === 1"
                  class="pointer d-flex align-center img-logo"
                  height="40px"
                  :src="require('@/assets/logo-pagina.png')"
                />
                <img
                  v-else-if="$route.meta.plataforma === 2"
                  class="pointer d-flex align-center img-logo"
                  height="40px"
                  :src="require('@/assets/logo-apisul-frotas.png')"
                />
              </div>
            </v-btn>
            <v-btn v-else class="button-logo" color="primary" dark depressed
              ><div>
                <img
                  class="pointer d-flex align-center img-logo"
                  height="40px"
                  :src="require('@/assets/logo-apisul-frotas.png')"
                />
              </div>
            </v-btn>
            <img
              v-show="$route.name !== 'GridSolicitacaoCotacao' && $route.name !== 'GridCadastroVeiculos'"
              :class="{ pointer: true, arrow: true, arrowDown: menuAtivo }"
              v-bind="attrs"
              v-on="on"
              :src="require('@/assets/arrow.svg')"
            />
          </template>
          <v-card class="primary py-0">
            <v-flex>
              <v-layout class="primary logos d-flex px-4">
                <img
                  class="pointer img-logo"
                  height="40px"
                  :src="require('@/assets/logo-pagina.png')"
                  @click="(plataforma = 1), goTo('/ListagemSolicitacoes')"
                />
                <img
                  class="pointer my-3 img-logo"
                  height="40px"
                  :src="require('@/assets/logo-apisul-frotas.png')"
                  @click="(plataforma = 2), goTo('/GridPrincipal')"
                />
              </v-layout>
            </v-flex>
          </v-card>
        </v-menu>
        <div v-else>
          <img
            v-if="$route.meta.plataforma === 1"
            class="pointer d-flex align-center img-logo"
            height="40px"
            :src="require('@/assets/logo-pagina.png')"
          />
          <img
            v-else-if="$route.meta.plataforma === 2"
            class="pointer d-flex align-center img-logo"
            height="40px"
            :src="require('@/assets/logo-apisul-frotas.png')"
          />
        </div>
      </div>
    </template>
    <img
      v-else
      @click="goTo('/Questionario')"
      class="pointer"
      height="40px"
      :src="require('@/assets/logo-pagina.png')"
    />
    <v-spacer></v-spacer>
    <template v-if="!$route.meta.hideLogin">
      <v-btn
        v-if="!usuarioHelperComputed.USUARIO_LOGADO()"
        color="white"
        to="/Login"
        active-class
        flat
        >Login</v-btn
      >
      <template v-else>
        <div class="notification-wrapper"  v-if="
          this.$route.path == '/GridPrincipal' &&
            permissoesComputed.verificaAcesso(
              this,
              'GridPrincipal'
            )
          "
          @click="abrirModalNotificacao"
        >
          <v-icon class="notification-icon"   :class="{ 'has-notification': hasNotification }">notifications</v-icon>
        </div>
        <span v-if="!$vuetify.breakpoint.xsOnly" class="body-2">{{
          usuarioHelperComputed.USUARIO_LOGADO().nome
        }}</span>
        <v-menu
          offset-y
          left
          max-height="88vh"
          transition="slide-y-transition"
          attach="#menuToolbar"
        >
          <v-btn slot="activator" icon flat color="white"
            ><v-icon>more_vert</v-icon></v-btn
          >
          <v-list class="pa-0">
            <v-list-tile v-if="$vuetify.breakpoint.xsOnly">
              <v-list-tile-action
                ><v-icon color="primary">person</v-icon></v-list-tile-action
              >
              <v-list-tile-content>
                <v-list-tile-title>{{
                  usuarioHelperComputed.USUARIO_LOGADO().nome
                }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-if="
                this.$route.path != '/ListagemSolicitacoes' &&
                  permissoesComputed.verificaAcesso(
                    this,
                    'ListagemSolicitacoes'
                  )
              "
              @click="goTo('/ListagemSolicitacoes')"
            >
              <v-list-tile-action
                ><v-icon color="primary">view_list</v-icon></v-list-tile-action
              >
              <v-list-tile-content>
                <v-list-tile-title>Listagem de Solicitações</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-if="
                this.$route.path != '/GridRelatorioProdutividade' &&
                  permissoesComputed.verificaAcesso(
                    this,
                    'GridRelatorioProdutividade'
                  )
              "
              @click="goTo('/GridRelatorioProdutividade')"
            >
              <v-list-tile-action>
                <v-icon color="primary" style="transform: rotate(180deg) scaleX(-1);">open_in_browser</v-icon></v-list-tile-action
              >
              <v-list-tile-content>
                <v-list-tile-title>Extração de Relatórios</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-if="
                this.$route.path != '/Questionario' || this.$route.path != '/Questionario' &&
                permissoesComputed.verificaAcesso(this, 'Questionario') || permissoesComputed.verificaAcesso(this, 'Questionario')
              "
              @click="goTo( usuarioHelperComputed.USUARIO_LOGADO() ? '/QuestionarioAnaliseRiscos' : '/Questionario' )"
            >
              <v-list-tile-action
                ><v-icon color="primary"
                  >description</v-icon
                ></v-list-tile-action
              >
              <v-list-tile-content>
                <v-list-tile-title>Cotar Seguro</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-if="
                this.$route.path != '/GridCadastroVeiculos' &&
                  permissoesComputed.verificaAcesso(
                    this,
                    'GridCadastroVeiculos'
                  )
              "
              @click="goTo('/GridCadastroVeiculos')"
            >
              <v-list-tile-action
                ><v-icon color="primary"
                  >local_shipping</v-icon
                ></v-list-tile-action
              >
              <v-list-tile-content>
                <v-list-tile-title>Cadastro Veículos</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-if="
                this.$route.path != '/GridSolicitacaoCotacao' &&
                  permissoesComputed.verificaAcesso(
                    this,
                    'GridSolicitacaoCotacao'
                  )
              "
              @click="goTo('/GridSolicitacaoCotacao')"
            >
              <v-list-tile-action
                ><v-icon color="primary">view_list</v-icon></v-list-tile-action
              >
              <v-list-tile-content>
                <v-list-tile-title>Listagem de Cotação</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-if="
                this.$route.path != '/GridConsultaItens' &&
                  permissoesComputed.verificaAcesso(
                    this,
                    'GridConsultaItens'
                  )
              "
              @click="goTo('/GridConsultaItens')"
            >
              <v-list-tile-action
                ><v-icon color="primary">search</v-icon></v-list-tile-action
              >
              <v-list-tile-content>
                <v-list-tile-title>Consulta de Itens</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-if="
                this.$route.path != '/Dashboard' &&
                  permissoesComputed.verificaAcesso(this, 'Dashboard')
              "
              @click="goTo('/Dashboard')"
            >
              <v-list-tile-action
                ><v-icon color="primary">pie_chart</v-icon></v-list-tile-action
              >
              <v-list-tile-content>
                <v-list-tile-title>Dashboard</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-if="
                this.$route.path != '/GestaoTaxasSeguro' &&
                  permissoesComputed.verificaAcesso(this, 'GestaoTaxasSeguro') &&
                  usuarioHelperComputed.USUARIO_LOGADO().gestaoTaxasSeguro
              "
              @click="goTo('/GestaoTaxasSeguro')"
            >
              <v-list-tile-action
                ><v-icon color="primary">table_chart</v-icon></v-list-tile-action
              >
              <v-list-tile-content>
                <v-list-tile-title>Gestão de Taxas de Seguro</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-if="
                this.$route.path != '/Auditoria' &&
                  permissoesComputed.verificaAcesso(this, 'Auditoria')
              "
              @click="goTo('/Auditoria')"
            >
              <v-list-tile-action
                ><v-icon color="primary">zoom_in</v-icon></v-list-tile-action
              >
              <v-list-tile-content>
                <v-list-tile-title>Auditoria do Sistema</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-if="
                this.$route.path != '/GestaoUsuarios' &&
                  permissoesComputed.verificaAcesso(this, 'GestaoUsuarios')
              "
              @click="goTo('/GestaoUsuarios')"
            >
              <v-list-tile-action
                ><v-icon color="primary">group</v-icon></v-list-tile-action
              >
              <v-list-tile-content>
                <v-list-tile-title>Usuário</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-if="
                this.$route.path != '/GestaoGrupos' &&
                  permissoesComputed.verificaAcesso(this, 'GestaoGrupos')
              "
              @click="goTo('/GestaoGrupos')"
            >
              <v-list-tile-action
                ><v-icon color="primary">group_work</v-icon></v-list-tile-action
              >
              <v-list-tile-content>
                <v-list-tile-title>Grupo de Usuários</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-if="
                this.$route.path != '/GestaoClientes' &&
                  permissoesComputed.verificaAcesso(this, 'GestaoClientes')
              "
              @click="goTo('/GestaoClientes')"
            >
              <v-list-tile-action
                ><v-icon color="primary"
                  >supervised_user_circle</v-icon
                ></v-list-tile-action
              >
              <v-list-tile-content>
                <v-list-tile-title>Cliente</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-if="
                this.$route.path != '/GridClassificacaoCotacoes' &&
                  permissoesComputed.verificaAcesso(this, 'GridClassificacaoCotacoes')
              "
              @click="goTo('/GridClassificacaoCotacoes')"
            >
              <v-list-tile-action
                ><v-icon color="primary">star</v-icon></v-list-tile-action
              >
              <v-list-tile-content>
                <v-list-tile-title>Classificação de Cotação</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-if="
                this.$route.path != '/GestaoPerfil' &&
                  permissoesComputed.verificaAcesso(this, 'GestaoPerfil')
              "
              @click="goTo('/GestaoPerfil')"
            >
              <v-list-tile-action
                ><v-icon color="primary">lock</v-icon></v-list-tile-action
              >
              <v-list-tile-content>
                <v-list-tile-title>Perfil</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="logout">
              <v-list-tile-action
                ><v-icon color="primary"
                  >exit_to_app</v-icon
                ></v-list-tile-action
              >
              <v-list-tile-content>
                <v-list-tile-title>Sair</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
      </template>
    </template>
  </v-toolbar>
</template>

<script>
import cipher from "@/helpers/cipher";
import permissoes from "@/helpers/permissoes";
import usuarioHelper from "@/helpers/usuario-logado";
import axios from "axios";

export default {
  name: "Menu",
  data() {
    return {
      get usuarioHelperComputed() {
        return usuarioHelper;
      },
      logado: false,
      plataforma: 1,
      menuAtivo: false,
      notificationList: [],
      notificaoObjeto: {
        idEndosso: null,
        numeroProposta: ""
      }
    };
  },
  computed: {
    hasNotification : function() {
      return this.notificationList.length > 0;
    },
    permissoesComputed: function() {
      return permissoes;
    },
    seguros() {
      return this.$store.getters["permissoes/temPermissaoSeguros"];
    },
    frota() {
      return this.$store.getters["permissoes/temPermissaoFrota"];
    },
    gridPrincipal() {
     return this.$route.path == '/GridPrincipal'
    }
  },
  watch: {
    gridPrincipal() {
      if(this.gridPrincipal) {
        this.buscarNotificacao()
      }
    }
  },
  methods: {
    logout: function() {
      localStorage.removeItem("token");
      this.$router.push("/Login");
      location.reload();
    },
    abrirModalNotificacao() {
      this.$emit("abrirModalNotificacao")
    },
    goTo: function(rota) {
      this.$router.push(rota);
    },
    async buscarNotificacao() {
      const response = await axios.get(`${process.env.URL_ENDOSSOMS}/v1/buscarNotificacoesEndossoCorretor`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        });
      if(response.data) {
        this.notificationList = response.data;
        this.$emit("tratarNotificacao", response.data)
      }
    },

  }
};
</script>

<style scoped>
.logos {
  flex-direction: column;
}

.menuLogo .v-menu__content {
  box-shadow: none;
  left: 24px !important;
  top: 12px !important;
}

.arrow {
  transition: 0.3s;
  transform: rotate(0deg);
  z-index: 13;
}

.arrowDown {
  transform: rotate(180deg);
}

.pointer {
  cursor: pointer;
}
.notification-wrapper{
  margin-right: 16px;
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.notification-icon {
  font-size: 26px;
  position: relative;
  display: block;
}

.notification-wrapper:hover {
  background-color: rgba(255, 255, 255, 0.35);
  border-radius: 50%;
  cursor: pointer;
}

.notification-icon.has-notification::before {
  content: "";
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: red;
  right: 1px;
  top: 2px;
}


@media (max-width: 600px) {
  .menuLogo .v-menu__content {
    left: 0px !important;
  }

  .logos {
    padding-left: 16px !important;
    padding-right: 10px !important;
  }

  .img-logo {
    width: 210px;
  }

  .button-logo {
    padding-left: 0px;
    margin-left: 0px;
    margin-right: 0px;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/shared/Menu.vue